import React, { Component, PropsWithChildren } from 'react';

export default class DialogBody extends Component<PropsWithChildren<any>> {
    public render() {
        return <div className="dialog-body">{this.props.children}</div>;
    }
}
